/**
 * Loads an iframe within an offcanvas lazily
 * Can be called when offcanvas opens or pre-loaded programmatically
 */

interface LoadOffcanvasIframeOptions {
  offcanvasId: string;
  scrollToBottom?: boolean;
}

function loadOffcanvasIframe(options: LoadOffcanvasIframeOptions): void {
  const { offcanvasId, scrollToBottom = true } = options;

  const offcanvas = document.getElementById(offcanvasId);
  if (!offcanvas) return;

  const iframe = offcanvas.querySelector('iframe[data-offcanvas-src]') as HTMLIFrameElement | null;
  const loader = offcanvas.querySelector('.offcanvas-iframe-loading');

  if (!iframe) return;

  // If already loaded, just show it
  if (iframe.src) {
    iframe.style.display = 'block';
    if (loader) loader.remove();
    return;
  }

  // Set up load handler
  iframe.addEventListener('load', function() {
    const isOffcanvasShown = offcanvas.classList.contains('show');

    if (loader) loader.remove();

    if (isOffcanvasShown) {
      this.style.display = 'block';
    }

    if (scrollToBottom) {
      // Scroll iframe content to bottom after load (for conversations)
      try {
        const iframeWindow = this.contentWindow;
        const iframeDocument = this.contentDocument || iframeWindow?.document;

        // Wait for iframe content to fully render
        setTimeout(function() {
          iframeWindow?.scrollTo(0, iframeDocument?.body.scrollHeight || 0);
        }, 75);
      } catch (e) {
        console.warn('Cannot scroll iframe:', e);
      }
    } else {
      // Keep scrolled to top (for profiles)
      try {
        const iframeWindow = this.contentWindow;
        iframeWindow?.scrollTo(0, 0);
      } catch (e) {
        console.warn('Cannot access iframe:', e);
      }
    }
  });

  // Set src to trigger load
  const srcUrl = iframe.getAttribute('data-offcanvas-src');
  if (srcUrl) {
    iframe.src = srcUrl;
  }

  // Mark iframe as loaded (different from event listener initialization)
  offcanvas.dataset.iframeLoaded = 'true';
}

// Make it available globally for inline script usage
(window as any).loadOffcanvasIframe = loadOffcanvasIframe;
